import { theme } from "@theme";
import styled from "styled-components";

export const RepostParent = styled.div<{isCandle?: boolean}>`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  border: 1px solid #e4d7cd;
  border-radius: 8px;
  background: #f9f2ec;
  height: fit-content;
  width: 360px;
  overflow: hidden;
  
  h4 {
    display: flex;
    gap: 8px;
    cursor: pointer;
    flex: 1;
    padding: 12px 16px;

    &:hover {background: rgba(240, 229, 222, 1)}
    img {
      width: 18px;
      height: 18px;
    }
  }

  @media screen and (max-width: ${theme.breakpoints.sm}) {
    width: 100% !important;
    background: transparent;
    border: ${({isCandle}) => isCandle ? "1px solid #e4d7cd" : "none"};
    
    h4 {
      flex: 1;
      padding: 12px 12px;
    }
  }
`;

export const RepostContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;

  @media screen and (max-width: ${theme.breakpoints.sm}) {
    padding: 17px 4px;
    background: #f9f2ec;
    border: 1px solid #e4d7cd;
  }
`;

export const RepostCopyTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`;

export const RepostCopyLine = styled.div`
  height: 1px;
  background: #c6a691;
  flex: 1;
  margin: 0 8px;
`;
export const RepostCopyInputWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding: 8px;
`;
export const RepostCopyButton = styled.button`
  width: 40px;
  height: 40px;
  background: #fff;
  border: 1px solid #e4d7cd;
  border-radius: 8px;
  padding: 8px;
  margin-left: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: #e4d7cd;
  }

  svg {
    font-size: 18px;
    color: #391d0a;
  }
`;
